/* global gApiConfig */
import $ from "jquery";
import { addCallback } from "./td";

var menuid = "#td-gridsetup";
var forID = "";

var touchEvents = "ontouchstart" in window;

function createMenu() {
	/* jshint validthis: true */
	var appurl = gApiConfig.appUrl;
	var backurl = gApiConfig.thisUrl;
	var id = this.parentNode.id;
	var menu = $(menuid);
	if(menu.length) {
		if(forID == id) {
			menu.show();
		}
		menu.remove();
	}
	forID = id;
	var cid = parseInt(id.substring(2));
	$("<ul/>", { id: menuid.substring(1), "class": "ui-popup" }).append(
		$("<li/>").append(
			$("<a/>", { id: "td-setupgear", "class": "ui-icon-setup ui-icon-only" }),
			$("<ul/>", { "class": "ui-popup" }).css("filter", "none").append(
				$("<li/>").append(
					$("<a/>", { href: appurl + "/setup/columnformadd.aspx?column=" + cid + "&back=" + backurl })
					.text("Add a column before this one")),
				$("<li/>").append(
					$("<a/>", { href: appurl + "/setup/columnformadd.aspx?after=1&column=" + cid + "&back=" + backurl })
					.text("Add a column after this one")),
				$("<li/>").append(
					$("<a/>", { href: appurl + "/setup/columnformremove.aspx?column=" + cid + "&back=" + backurl })
					.text("Remove this column from the form")),
				$("<li/>").append(
					$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&back=" + backurl })
					.text("Edit the column's form properties")),
				$("<li/>").append(
					$("<a/>", { href: appurl + "/setup/columnedit.aspx?column=" + cid + "&back=" + backurl })
					.text("Edit the column's properties")),
				$("<li/>").append(
					$("<a/>", { href: "#" }).text("Lay out row in 1 column").on("click", false),
					$("<ul/>", { "class": "ui-popup" }).append(
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1000&back=" + backurl })
							.text("\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=2000&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=3000&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=4000&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588"))
						)),
				$("<li/>").append(
					$("<a/>", { href: "#" }).text("Lay out row in 2 columns").on("click", false),
					$("<ul/>", { "class": "ui-popup" }).append(
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1100&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1200&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=2100&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u00A0\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=2200&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u00A0\u2588\u2588\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1300&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u2588\u2588\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=3100&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u2588\u2588\u00A0\u2588\u2588"))
					)),
				$("<li/>").append(
					$("<a/>", { href: "#" }).text("Lay out row in 3 columns").on("click", false),
					$("<ul/>", { "class": "ui-popup" }).append(
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1110&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u00A0\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=2110&back=" + backurl })
							.text("\u2588\u2588\u2588\u2588\u00A0\u2588\u2588\u00A0\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1210&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u2588\u2588\u00A0\u2588\u2588")),
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1120&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u00A0\u2588\u2588\u2588\u2588"))
						)),
				$("<li/>").append(
					$("<a/>", { href: "#" }).text("Lay out row in 4 columns").on("click", false),
					$("<ul/>", { "class": "ui-popup" }).append(
						$("<li/>").append(
							$("<a/>", { href: appurl + "/setup/columnformprop.aspx?column=" + cid + "&layout=1111&back=" + backurl })
							.text("\u2588\u2588\u00A0\u2588\u2588\u00A0\u2588\u2588\u00A0\u2588\u2588"))
					)),
                $("<li/>").append(
					$("<a/>", { href: appurl + "/setup/formorder.aspx?table=" + gApiConfig.currentTableId + "&back=" + backurl })
					.text("Reorder columns"))
				)
			)
		)
	.menu({
		select: function(event, ui) {
			var link = ui.item.children("a:first");
			if(link.attr("href") == "#")
				return false;
		}
	})
	.appendTo(this)
	.show()
	.position({
		my: "left top",
		at: "left top",
		of: this
	});
}

function removeMenu(e) {
	var to = $(e.toElement || e.relatedTarget);
	if(to.closest(menuid).length)
		return;
	$(menuid).hide();
}

addCallback(function() {
	var dtSelector = "dl[id^=\"f_\"][id$=\"_label\"]>dt";
	var ctx = $("form.fs-setup>section>div.ui-gridlayout");
	ctx.on(touchEvents ? "touchend" : "mouseenter", dtSelector, createMenu);
	if(!touchEvents)
		ctx.on("mouseleave", dtSelector, removeMenu);
});
